import React from "react";
import { defineMessages, injectIntl } from 'react-intl';

class NotifyMessage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="notify-message-container">
        {this.props.body}
      </div>
    )
  }
}

export default injectIntl(NotifyMessage);